export const EDaoHomeViewMode = {
  Preview: "Preview",
  Edit: "Edit",
  Widget: "Widget",
} as const;

export type EDaoHomeViewMode =
  typeof EDaoHomeViewMode[keyof typeof EDaoHomeViewMode];
